import CartCancelIcon from "../CartCancelIcon";
import CaretDownPD1 from "./CaretDownPD1";
import CaretDownPD2 from "./CaretDownPD2";
import CaretDownPD3 from "./CaretDownPD3";
import "./GridRow2ndPageRow2(300-600px).css";
import "./GridRow2ndPageRow2.css";
import ProductDetailsCancelIcon from "./ProductDetailsCancelIcon";
import RightArrowForCartPage from "./RightArrowForCartPage";
import RightArrowForCartPage2 from "./RightArrowForCartPage2";
import RightArrowForCartPage3 from "./RightArrowForCartPage3";
import StarRating from "./StarRating";
const GridRow2ndPageRow2 = () => {
  function ProductDetailsHandler() {
    document
      .getElementById("ProductDetailsBoxId")
      .classList.add("ProductDetailsBoxShow");
    document.getElementById("BackDrop").classList.add("menuBackDropHandler");
  }
  function CaretDownPD1Handler() {
    document
      .getElementById("CaretDownPD1Id")
      .classList.toggle("ProductDetailsBoxDropDown1Show");
  }
  function CaretDownPD2Handler() {
    document
      .getElementById("CaretDownPD2Id")
      .classList.toggle("ProductDetailsBoxDropDown1Show");
  }
  function CaretDownPD3Handler() {
    document
      .getElementById("CaretDownPD3Id")
      .classList.toggle("ProductDetailsBoxDropDown1Show");
  }

  return (
    <>
      <div onClick={ProductDetailsHandler} className="GridRow2ndPageRow21">
        <p>Product Details</p>
        <RightArrowForCartPage />
      </div>
      <div className="GridRow2ndPageRow22">
        <p>Measurements</p>
        <RightArrowForCartPage2 />
      </div>
      <div className="GridRow2ndPageRow23">
        <div className="ReviewWithStars">
          <p>Reviews</p>
          <StarRating />
          <StarRating />
          <StarRating />
          <StarRating />
          <StarRating />
        </div>
        <RightArrowForCartPage3 />
      </div>
      <div id="ProductDetailsBoxId" className="ProductDetailsBoxHide">
        <div className="ProductDetailsCancelIcon"><ProductDetailsCancelIcon /></div>
        <p className="ProductDetailsBoxHeading">Product details</p>
        <p className="ProductDetailsBoxPrice">MRP Rs.3,133 (incl. tax)</p>
        <div className="ProductDetailsBoxParas">
          <p>
            A quilted mattress protector with a lyocell and cotton blend fabric
            and a lyocell and polyester filling. The polyester filling is mainly
            from recycled sources.
          </p>
          <p>
            A mattress protector between your sheet and mattress protects from
            stains and dirt and prolongs the life of your mattress.
          </p>
          <p>
            You experience a comfortable and dry sleep since both the fabric and
            filling contain lyocell fibres which absorb moisture.
          </p>
          <p>
            An elastic strap in each corner keeps your mattress protector in
            place.
          </p>
          <p>
            The mattress protector is machine-washable at 60°C, a temperature
            that kills dust mites.
          </p>
        </div>
        <div>
          <p>
            <b>Designer</b>
          </p>{" "}
          <p style={{ color: "grey" }}>Maja Ganszyniec</p>{" "}
          <p>
            <b>Country of Origin</b>
          </p>{" "}
          <p style={{ color: "grey" }}>China, India</p>
          <p style={{ color: "grey" }}>Article number</p>
          <p className="ArticleButton">004.619.92</p>
        </div>
        <div className="ProductDetailsBoxDropDown">
          <div className="ProductDetailsBoxDropDown1">
            <div
              className="ProductDetailsBoxDropDown11"
              onClick={CaretDownPD1Handler}
            >
              <h6>Good to know</h6>
              <CaretDownPD1 />
            </div>
            <div id="CaretDownPD1Id" className="ProductDetailsBoxDropDown1Hide">
              <p>236 thread count.</p>
              <p>
                Thread count indicates the number of threads per square inch of
                fabric. The higher the thread count the more densely woven the
                fabric.
              </p>
              <p>
                This product is flammability tested and complies with standard
                EN ISO 12952-1.
              </p>
              <p>
                This product is flammability tested in accordance to standard
                CAN/CGSB 4.2 No 27.5 and meets the requirement of flame spread
                time ≥7.1 sec.
              </p>
              <p>
                Fits mattresses with a max. height of 42 cm, since the mattress
                protector has elastic ribbon in each corner.
              </p>{" "}
            </div>
          </div>

          <div className="ProductDetailsBoxDropDown2">
            <div
              className="ProductDetailsBoxDropDown21"
              onClick={CaretDownPD2Handler}
            >
              <h6> Materials & care </h6>
              <CaretDownPD2 />
            </div>
            <div id="CaretDownPD2Id" className="ProductDetailsBoxDropDown2Hide">
              <p>
                By using renewable materials like cellulose and cotton fibres in
                this product, we avoid using fossil or finite materials.
              </p>{" "}
              <p>
                Lyocell is a cellulose fibre made of wood. Wood is a renewable
                material and needs less water, pesticides and artificial
                fertilisers to grow than, for example, cotton.
              </p>{" "}
              <p>
                We want to have a positive impact on the planet. That is why by
                2030, we want all materials in our products to be recycled or
                renewable, and sourced in responsible ways.
              </p>{" "}
              <p>
                Lyocell is produced in a closed process. Most of the added
                substances are recycled or reused, which is part of our ambition
                to reduce our environmental impact.
              </p>{" "}
              <p>
                The cotton in this product is grown with less water, less
                chemical fertilizers and less chemical pesticides, while
                increasing profit margins for the farmers. That way, we lower
                our environmental impact.
              </p>{" "}
              <p>
                By using recycled polyester in this product, we consume less new
                raw materials and lower our environmental impact while existing
                materials get new life.
              </p>{" "}
            </div>
          </div>

          <div className="ProductDetailsBoxDropDown3">
            <div
              className="ProductDetailsBoxDropDown31"
              onClick={CaretDownPD3Handler}
            >
              <h6 > Sustainability & environment</h6>
              <CaretDownPD3 />
            </div>
            <div id="CaretDownPD3Id" className="ProductDetailsBoxDropDown3Hide">
              <p>
                By using renewable materials like cellulose and cotton fibres in
                this product, we avoid using fossil or finite materials.
              </p>{" "}
              <p>
                Lyocell is a cellulose fibre made of wood. Wood is a renewable
                material and needs less water, pesticides and artificial
                fertilisers to grow than, for example, cotton.
              </p>{" "}
              <p>
                We want to have a positive impact on the planet. That is why by
                2030, we want all materials in our products to be recycled or
                renewable, and sourced in responsible ways.
              </p>{" "}
              <p>
                Lyocell is produced in a closed process. Most of the added
                substances are recycled or reused, which is part of our ambition
                to reduce our environmental impact.
              </p>{" "}
              <p>
                The cotton in this product is grown with less water, less
                chemical fertilizers and less chemical pesticides, while
                increasing profit margins for the farmers. That way, we lower
                our environmental impact.
              </p>{" "}
              <p>
                By using recycled polyester in this product, we consume less new
                raw materials and lower our environmental impact while existing
                materials get new life.
              </p>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GridRow2ndPageRow2;
